import React from 'react';
import * as util from "../../../other/util.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";
import FleetStep from "./fleet-step.js";

export class PendingColonizeFleetStep extends FleetStep {
    constructor(props) {
        super("COLONIZE");
    }

    render(props, idx) {
        let duration = FleetFormulas.getTimeForColonize();

        return (
            <div>
                <div>
                    <span className="boring-info-text">Colonization time: </span>
                    <util.NiceInlineTimeSpan timeSpan={duration} />
                </div>
            </div>);
    }
}

export class FixedColonizeFleetStep extends FleetStep {
    render(props, idx) {
        let task = props.task;
        let step = task.steps[idx];

        if (this._isStepDone(props, idx)) {
            return this._renderDone("Colonizing", idx);
        }

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (this.isStepActive(props, idx)) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <span className="boring-info-text">Colonizing: </span>
                <br />
                <span>
                    <span className="boring-info-text">Colonization time: </span>
                    {timer}
                </span>
            </div>);
    }
}
